import { watch } from 'vue';
import { useI18n } from 'vue-i18n';

export default {
  components: {},
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    }
  },
  setup(props) {
    const { t } = useI18n();
    watch(() => props.isOpen, (val) => {
      if (val) {
        document.body.style.top = `-${window.scrollY}px`;
        document.body.classList.add(`style--fixed`);
        // document.getElementById("app-main-page").className = 'style--fixed';
      }
      else {
        const scrollY = document.body.style.top;
        document.body.style.top = '';
        document.body.classList.remove('style--fixed');
        window.scrollTo(0, parseInt(scrollY || '0') * -1);

      }
    }) //end: watch

    return {
      t

    }//end: return;
  }
}


